import { getLabel } from './theme.selectors'

export const sortByLabel = (themes = []) =>
  themes.sort((first, second) =>
    getLabel(first).toLowerCase().trim().localeCompare(getLabel(second).toLowerCase().trim()),
  )
